import ServiceLandingPage from "../../ServiceLandingPage/ServiceLandingPage";

const corporateRecruitmentService = {
  contentKey: "servicePages.corporateRecruitment",
  layout: "person-content",
  image: "/service-corporate-recruitment.png",
  heroPosition: "center 1%",
  heroContentSx: {
    pt: { xs: 3, md: 12 },
  },
  heroTitleSx: {
    mb: 2,
  },
  heroDescriptionSx: {
    mb: 2.5,
  },
  contentContainerSx: {
    pt: { xs: 3, md: 3 },
  },
  hideContentCta: true,
  personInRequest: true,
  defaultRequestExpanded: true,
  person: {
    image: "/team-theresa-dietrich.jpeg",
  },
};

const CorporateRecruitmentPage = () => {
  return <ServiceLandingPage service={corporateRecruitmentService} />;
};

export default CorporateRecruitmentPage;
